




























import { RARITY } from "@/constants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class BasePowaComponent extends Vue {
  rCount = 0;
  powaColor = "white";
  get styles() {
    return {
      "--powa-color": this.powaColor,
    };
  }
  @Prop() targetRarity!: RARITY;
  mounted(): void {
    const refs = [
      this.$refs.r1,
      this.$refs.r4,
      this.$refs.r7,
      this.$refs.r2,
      this.$refs.r5,
      this.$refs.r9,
      this.$refs.r3,
      this.$refs.r6,
      this.$refs.r8,
    ];
    // 真ん中で集合するポワ
    setTimeout(() => {
      refs.forEach((v, i) =>
        setTimeout(() => {
          (v as HTMLElement).classList.add("zoom");
        }, 65 * i)
      );
    }, 500);
    // ポワの色変え
    setTimeout(() => {
      this.changePowaColor();
    }, 2000);
  }
  changePowaColor() {
    const seed = Math.random();
    const blue = "rgba(135, 206, 235, 0.3)";
    const gold = "rgba(255, 215, 0, 0.3)";
    switch (this.targetRarity) {
      case RARITY.R:
        this.powaColor = blue;
        break;
      case RARITY.SR:
      case RARITY.SSR: // TODO 虹できたらそちらに変更
        if (seed < 0.4) {
          this.powaColor = blue;
        } else {
          this.powaColor = gold;
        }
        break;
    }
    this.targetRarity;
  }
  rapidAnimEnd(e: AnimationEvent): void {
    // アニメーション名を前方一致で確認（後ろにはvue特有の文字列がくるため）
    if (e.animationName.indexOf("zoomin-rapid-powa") === 0) {
      (e.target as HTMLElement).classList.add("z0");
    } else if (e.animationName.indexOf("closer-rapid-powa") === 0) {
      this.rCount++;
      if (this.rCount === 9) {
        // 最後のひとつだけ爆発させる
        (e.target as HTMLElement).classList.add("explosion-powa");
      } else {
        // 他は消滅させる
        (e.target as HTMLElement).style.display = "none";
      }
    } else if (e.animationName.indexOf("explosion-powa") === 0) {
      this.$emit("endallanimation");
    }
  }
}
